// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0882938f","239":"a78adc58","607":"441d936d","732":"f1dc4ff3","762":"bbfc6088"}[chunkId] + ".chunk.js";
};